export default __webpack_public_path__ + "1a37f6167b91c2d0c894484b7c4ea656.webp";